

import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicModel } from "../../model/BasicModel";
import { SimpleCommand } from "./../../../commanding/SimpleCommand";

export class BasicLoginCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        BasicController.getInstance().onLogIn();

        if (EnvGlobalsHandler.globals.pln !== "" && EnvGlobalsHandler.globals.sig !== "") {
            BasicModel.smartfoxClient.sendMessage(
                BasicSmartfoxConstants.C2S_LOGIN_SOCIAL,
                [
                    EnvGlobalsHandler.globals.pln,                      // social login name
                    EnvGlobalsHandler.globals.sig,                      // access key
                    BasicModel.smartfoxClient.connectionTime,           // connect time
                    BasicModel.smartfoxClient.roundTripTime,            // ping
                    EnvGlobalsHandler.globals.cleanReferrer,            // referrer
                    EnvGlobalsHandler.globals.networkId,                // network id
                    EnvGlobalsHandler.globals.accountId,                // account id
                    "",                                                 // support key
                    "",                                                 // time zone
                    EnvGlobalsHandler.globals.urlVariables.loginSource
                ]
            );
        } else {
            BasicController.getInstance().sendServerMessageAndWait(
                BasicSmartfoxConstants.C2S_LOGIN,
                [
                    BasicModel.userData.userName,
                    BasicModel.userData.loginPwd,
                    BasicModel.smartfoxClient.connectionTime.toString(),
                    BasicModel.smartfoxClient.roundTripTime.toString(),
                    EnvGlobalsHandler.globals.accountId.toString()
                ],
                BasicSmartfoxConstants.C2S_LOGIN
            );
        }
    }
}

